import {Component, OnInit} from '@angular/core';
import { AdminService } from '../../../services/admin.service';
import {AbstractControl, FormControl, FormGroup, ValidatorFn, Validators} from '@angular/forms';
import {UserSecurityConfig} from '../../../Models/userSecurityConfig';
import {CustomValidator} from '../../../services/custom-validator';

@Component({
  selector: 'app-userSecurityConfig',
  templateUrl: './userSecurityConfig.component.html',
  styleUrls: ['./userSecurityConfig.component.css']
})
export class UserSecurityConfigComponent implements OnInit {

  securityForm: FormGroup;
  saveConfigurationProgress: boolean;
  saveConfigurationSucess: boolean;
  errorMessage: string;


  get formData() { return this.securityForm.controls; }

  constructor(private admService: AdminService) {
  }

  ngOnInit() {
    this.saveConfigurationProgress = false;
    this.saveConfigurationSucess = false;
    this.errorMessage = '';
    this.createForm();
    this.loadConfig();
  }



  createForm() {
    this.securityForm = new FormGroup({
      userSecurityConfigId: new FormControl(Validators.required),
      passwordExpirationTime: new FormControl(0,[CustomValidator.numeric, Validators.max(9223372036854775807)]),
      minNumberChar: new FormControl(0, [CustomValidator.numeric, Validators.max(9223372036854775807)]),
      hasUppercaseChar: new FormControl(),
      hasLowercaseChar: new FormControl(),
      hasNumericChar: new FormControl(),
      hasSpecialChar: new FormControl(),
      numberPasswordAttempt: new FormControl(0,[CustomValidator.numeric, Validators.max(9223372036854775807)]),
      numberQuizAttempt: new FormControl(0,[CustomValidator.numeric, Validators.max(9223372036854775807)]),
      numberRecentPassword: new FormControl(0,[CustomValidator.numeric, Validators.max(5)]),
      notHasLoginInPassword: new FormControl(),
      hasSecurityQuiz: new FormControl(),
      hasAnyPasswordRule: new FormControl(),
      stringRules: new FormControl()
    } as UserSecurityConfigControls) as UserSecurityConfigFormGroup;
  }

  positiveNumberValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: any } => {
      const isNotOk = Number(control.value) < 0;
      return isNotOk ? { nonPositive: { value: control.value } } : null;
    };
  }


  private loadConfig() {
    this.errorMessage = '';
    this.admService.getUserSecurityConfig()
      .subscribe((config : UserSecurityConfig) => {
        if (config) {
          this.securityForm.setValue(config);
        }
      }, error1 => this.errorMessage = error1);
  }

  save() {
    this.saveConfigurationProgress = true;
    this.saveConfigurationSucess = false;
    this.errorMessage = '';
    var config = this.securityForm.value;

    this.admService.udpateUserSecurityConfig(config)
      .subscribe(
        resp => {
        this.saveConfigurationProgress = false;
        this.saveConfigurationSucess = true;
      },
        err =>{
          this.errorMessage = err;
          this.saveConfigurationProgress = false;
          this.saveConfigurationSucess = false;
        });
  }
}

type UserSecurityConfigControls = { [key in keyof UserSecurityConfig]: AbstractControl };
type UserSecurityConfigFormGroup = FormGroup & { value: UserSecurityConfig, controls: UserSecurityConfigControls };

